import React from 'react';
import { func, string, number, arrayOf, shape } from 'prop-types';
import { connect } from 'react-redux';

import locationShape from 'propTypes/locationShape';
import coord from 'propTypes/coord';
import segmentStatus from 'propTypes/segmentStatus';

import { operations } from 'state/ducks/map';
import addObjectPriority from 'helpers/addObjectPriority';

import Route from 'components/Map/MapComponents/Route';

export function RouteGroup({
  routes,
  selectEntity,
  enterEntity,
  leaveEntity,
  routeParams,
  currentHover,
}) {
  // eslint-disable-next-line global-require
  const SortingFeatureGroup = require('components/Map/MapComponents/SortingFeatureGroup').default;

  const hoveredId = currentHover && currentHover.id;
  const selectedId = routeParams && routeParams.id;

  const sortedRoutesWithPriority = routes
    .map(route => addObjectPriority(route, hoveredId, selectedId))
    .sort((routeA, routeB) => routeA.priority - routeB.priority);

  return (
    <SortingFeatureGroup>
      {sortedRoutesWithPriority.map(route =>
        <Route
          key={`Route-${route.id}${route.id === selectedId || route.id === currentHover
            ? '-active'
            : ''}`}
          route={route}
          isSelected={route.id === selectedId}
          isHovered={route.id === hoveredId}
          onSelect={() => {
            selectEntity({
              id: route.id,
              type: 'route',
            });
          }}
          onEnter={() =>
            enterEntity({
              id: route.id,
              type: 'route',
            })}
          onLeave={() =>
            leaveEntity({
              id: route.id,
              type: 'route',
            })}
        />
      )}
    </SortingFeatureGroup>
  );
}

RouteGroup.propTypes = {
  routes: arrayOf(
    shape({
      id: string,
      name: string,
      segments: arrayOf(
        shape({
          id: string,
          from: locationShape,
          to: locationShape,
          path: arrayOf(coord),
          liveTravelTime: number.isRequired,
          status: segmentStatus,
        })
      ),
    })
  ).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  routeParams: shape({
    id: string,
  }).isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

export default connect(mapStateToProps, operations)(RouteGroup);



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/RouteGroup/index.js